module.exports = __webpack_public_path__ + "static/media/clocards-display.0f7a731b.png";